@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Georgia</h2>
  @if (reactiveForm) {
    <p>Please select one of the following options:</p>
    <form [formGroup]="reactiveForm">
      <!--Level 1 radio buttons-->
      <div
        class="axis-form-group _mt-medium"
        [ngClass]="{
          'has-axis-required': reactiveForm.get(controls[0].formControlName)?.value === null,
          'has-axis-error':
            reactiveForm.get(controls[0].formControlName)?.touched &&
            reactiveForm.get(controls[0].formControlName)?.invalid,
        }"
      >
        @if (controls?.length >= 1) {
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[0].formControlName)?.touched) {
            @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        }
      </div>
      <!--Level 2 radio buttons-->
      <div
        class="axis-form-group _mt-medium"
        [ngClass]="{
          'has-axis-required': reactiveForm.get(controls[1].formControlName)?.value === null,
          'has-axis-error':
            reactiveForm.get(controls[1].formControlName)?.touched &&
            reactiveForm.get(controls[1].formControlName)?.invalid,
        }"
      >
        @if (controls?.length >= 2) {
          <axis-radio-button-wrapper formControlName="{{ controls[1].formControlName }}">
            @for (control of controls[1].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[1].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[1].formControlName)?.touched) {
            @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        }
      </div>
      <!--Level 3 radio buttons-->
      <div
        class="axis-form-group _mt-medium"
        [ngClass]="{
          'has-axis-required': reactiveForm.get(controls[2].formControlName)?.value === null,
          'has-axis-error':
            reactiveForm.get(controls[2].formControlName)?.touched &&
            reactiveForm.get(controls[2].formControlName)?.invalid,
        }"
      >
        @if (controls?.length >= 3) {
          <axis-radio-button-wrapper formControlName="{{ controls[2].formControlName }}">
            @for (control of controls[2].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[2].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[2].formControlName)?.touched) {
            @if (reactiveForm.get(controls[2].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        }
      </div>
      <!-- Min Limits dropdown read-only -->
      @if ((baseRules?.["Reduced_UMBI_UMPD_CombinedSingleMinLimit_DropDown"] || "").includes("readonly")) {
        <div class="axis-grid">
          <div class="axis-col-sm-6 axis-col-md-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[15].label }}</label>
              <div id="reduced_umbi_umpd_combinedsingleminlimit_75k-pdffield-georgia">
                {{ controls[15].data[0].name }}
              </div>
            </div>
          </div>
        </div>
      }
      @if ((baseRules?.["Added_UMBI_UMPD_CombinedSingleMinLimit_DropDown"] || "").includes("readonly")) {
        <div class="axis-grid">
          <div class="axis-col-sm-6 axis-col-md-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[9].label }}</label>
              <div id="added_umbi_umpd_combinedsingleminlimit_75k-pdffield-georgia">{{ controls[9].data[0].name }}</div>
            </div>
          </div>
        </div>
      }
      @if ((baseRules?.["Reduced_BI_SplitMinLimits_DropDown"] || "").includes("readonly")) {
        <div class="axis-grid">
          <div class="axis-col-sm-6 axis-col-md-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[13].label }}</label>
              <div id="reduced_bi_splitminlimits_25k_50k-pdffield-georgia">{{ controls[13].data[0].name }}</div>
            </div>
          </div>
        </div>
      }
      @if ((baseRules?.["Added_BI_SplitMinLimits_DropDown"] || "").includes("readonly")) {
        <div class="axis-grid">
          <div class="axis-col-sm-6 axis-col-md-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[7].label }}</label>
              <div id="added_bi_splitminlimits_25k_50k-pdffield-georgia">{{ controls[7].data[0].name }}</div>
            </div>
          </div>
        </div>
      }
      @if ((baseRules?.["Reduced_PD_CombinedSingleMinLimit_DropDown"] || "").includes("readonly")) {
        <div class="axis-grid">
          <div class="axis-col-sm-6 axis-col-md-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[14].label }}</label>
              <div id="reduced_pd_combinedsingleminlimit_25k-pdffield-georgia">{{ controls[14].data[0].name }}</div>
            </div>
          </div>
        </div>
      }
      @if ((baseRules?.["Added_PD_CombinedSingleMinLimit_DropDown"] || "").includes("readonly")) {
        <div class="axis-grid">
          <div class="axis-col-sm-6 axis-col-md-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[8].label }}</label>
              <div id="added_pd_combinedsingleminlimit_25k-pdffield-georgia">{{ controls[8].data[0].name }}</div>
            </div>
          </div>
        </div>
      }
      @if ((baseRules?.["LiabilityLimit_Added_DropDown"] || "").includes("readonly")) {
        <div class="axis-grid">
          <div class="axis-col-sm-6 axis-col-md-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[18].label }}</label>
              <div id="added_umbi_umpd_combinedsinglelimit_Limit_equal_to_the_limit_of_my_Liability_Coverage-pdffield-georgia">{{ controls[18].data[0].name }}</div>
            </div>
          </div>
        </div>
      }
      @if ((baseRules?.["LiabilityLimit_Reduced_DropDown"] || "").includes("readonly")) {
        <div class="axis-grid">
          <div class="axis-col-sm-6 axis-col-md-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[19].label }}</label>
              <div id="reduced_umbi_umpd_combinedsinglelimit_Limit_equal_to_the_limit_of_my_Liability_Coverage-pdffield-georgia">{{ controls[19].data[0].name }}</div>
            </div>
          </div>
        </div>
      }
      <!--Dropdowns for limits-->
      <div class="axis-grid">
        @for (control of controls | slice: 4 : 16; track $index) {
          @if (baseRules[control.baseRuleKey]?.includes("show") || baseRules[control.baseRuleKey]?.includes("form")) {
            <div class="axis-col-sm-8 axis-col-md-8">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                  >{{ control.label }}</label
                >
                <axis-dropdown
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select an option.</span
                    >
                  }
                }
              </div>
            </div>
          }
        }
      </div>
      <!--Deductible radio buttons-->
      <div
        class="axis-form-group _mt-medium"
        [ngClass]="{
          'has-axis-required': reactiveForm.get(controls[3].formControlName)?.value === null,
          'has-axis-error':
            reactiveForm.get(controls[3].formControlName)?.touched &&
            reactiveForm.get(controls[3].formControlName)?.invalid,
        }"
      >
        @if (controls?.length >= 4) {
          @if ((baseRules?.["No_Deductible_LevelThree_Radio"] || "").includes("show")) {
            <p>Deductible Options:</p>
          }
          <axis-radio-button-wrapper formControlName="{{ controls[3].formControlName }}">
            @for (control of controls[3].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[3].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[3].formControlName)?.touched) {
            @if (reactiveForm.get(controls[3].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        }
      </div>
      <!--Dropdowns Deductibles-->
      <div class="axis-grid">
        @for (control of controls | slice: 16; track $index) {
          @if (baseRules[control.baseRuleKey]?.includes("show") || baseRules[control.baseRuleKey]?.includes("form")) {
            <div class="axis-col-sm-8 axis-col-md-8">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                  >{{ control.label }}</label
                >
                <axis-dropdown
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select an option.</span
                    >
                  }
                }
              </div>
            </div>
          }
        }
      </div>
    </form>
    <p>{{ textValues?.description }}</p>
  }
}
@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Georgia</h2>
  @if (baseRules?.Reject_LevelTwo_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label"> {{ textValues?.Reject_Text }} </label>
    </div>
  }
}
